import React from 'react';
import classNames from 'classnames';
import { isCurrencySymbolLeading } from 'utils/currencyUtil';

import styles from './style.module.scss';

// The free-text amount beside the preset buttons. The symbol sits on the side the currency's own
// format puts it ("£ 250", "250 €"), and is folded into the accessible name because the rendered
// one is decoration.
const AmountInput = ({ currencyCode, symbol, label, selected = false, ...inputProps }) => {
  const isSymbolLeading = isCurrencySymbolLeading(currencyCode);
  const currencySymbol = (
    <span className={styles.amountOtherSymbol} aria-hidden="true">
      {symbol}
    </span>
  );

  return (
    <span className={classNames(styles.amountOtherWrap, { [styles.selected]: selected })}>
      {isSymbolLeading && currencySymbol}
      <input
        className={styles.amountOther}
        placeholder={label}
        aria-label={isSymbolLeading ? `${symbol} ${label}` : `${label} ${symbol}`}
        {...inputProps}
      />
      {!isSymbolLeading && currencySymbol}
    </span>
  );
};

export default AmountInput;
